module.exports = __webpack_public_path__ + "static/media/icon.f56da436.svg";